import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {groupBy, map, filter, sortBy, get} from 'lodash';
import {
    LoadChallengeVersionsAction,
    ErrorMessageAction,
    LoadingAction,
    Cookie,
    SetLibraryMeasureAction
} from "mindsets-js-sdk";

import ActiveChallenge from './ActiveChallenge';
import ChallengesFilter from './ChallengesFilter';
import NoChallenges from './NoChallenges';
import {MEASURE_COOKIE_NAME} from 'constants/index';
import {sortCategories, getCategoryText} from "common/challengeNew/utils";

export default function Challenges() {
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const challenge_versions = useSelector(state => state.challenge_versions);
    const subject = useSelector(state => state.library_subject);
    const grade = useSelector(state => state.library_grade);
    const theme = useSelector(state => state.library_theme);
    const topic = useSelector(state => state.library_topic);
    const measure = useSelector(state => state.library_measure);
    const [loading, setLoading] = useState(true);

    function getChallengesFromServer() {
        setLoading(true);
        dispatch(LoadChallengeVersionsAction({limit: 0}))
            .catch(error => {
                console.error(error);
                dispatch(ErrorMessageAction(error));
            })
            .then(() => {
                setLoading(false);
                dispatch(LoadingAction(false));
            });
    }

    function setMeasure() {
        let measure_new = 'metric'
        if (!me || !me.country || 'US' === me.country) {
            measure_new = 'imperial';
        }
        const cookie_measure = Cookie.getCookie(MEASURE_COOKIE_NAME);
        if (cookie_measure) {
            measure_new = cookie_measure;
        }
        if (measure_new !== measure) {
            dispatch(SetLibraryMeasureAction(measure_new));
        }
    }

    function filterChallenges() {
        const school_curriculum_id = get(me, 'school.curriculum_id', 1);

        return filter(challenge_versions, (challenge_version) => {
            if ('active' !== challenge_version.challenge_code.status) {
                return false;
            }
            if (challenge_version.challenge_code.subject !== subject) {
                return false;
            }
            if (topic && '' !== topic) {
                if (challenge_version.challenge_code.standards
                    .filter(standard => (standard.curriculum_id === school_curriculum_id) && standard.topic === topic)
                    .length <= 0) {
                    return false;
                }
            }
            if (grade && '' !== grade) {
                if (challenge_version.challenge_code.standards
                    .filter(standard => (standard.curriculum_id === school_curriculum_id) && standard.grade === grade)
                    .length <= 0) {
                    return false;
                }
            }
            if (theme && '' !== theme) {
                if (challenge_version.challenge_code.themes.indexOf(theme) < 0) {
                    return false;
                }
            }
            if (measure && '' !== measure) {
                if (challenge_version.challenge_code.measure && challenge_version.challenge_code.measure.indexOf(measure) < 0) {
                    return false;
                }
            }

            return true;
        });
    }

    function renderLoader() {
        if (loading) {
            return (
                <div className="section">
                    <div className="progress">
                        <div className="indeterminate"/>
                    </div>
                </div>
            );
        }
    }

    function renderChallenges() {
        if (!me) {
            return null;
        }
        const challenge_versions = filterChallenges();
        if (challenge_versions.length <= 0 && false === loading) {
            return (
                <NoChallenges
                    challenge_versions={challenge_versions}
                />
            );
        }
        const grade_translated_challenges = map(challenge_versions, (c) => {
            const challenge_version = JSON.parse(JSON.stringify(c));
            const grade = me.curriculum && challenge_version.challenge_code.grades[me.curriculum.code] ? challenge_version.challenge_code.grades[me.curriculum.code] : challenge_version.challenge_code.grades.default
            challenge_version.grade_translated = getCategoryText(grade);

            return challenge_version;
        })
        const ordered_challenges = sortBy(grade_translated_challenges, (c) => c.name)
        const categorised_challenges = groupBy(ordered_challenges, (c) => c.grade_translated)

        return map(sortCategories(categorised_challenges), (category, grade) => {
            return (
                <div className="section" key={grade}>
                    <h4 className="header-new">
                        {grade}
                    </h4>
                    <div className="row">
                        {
                            category.map((challenge_version, k) => {
                                return (
                                    <div className="col" key={k}>
                                        <ActiveChallenge challenge_version={challenge_version}/>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="divider"/>
                </div>
            );
        });
    }

    useEffect(() => {
        setMeasure();
        getChallengesFromServer();
        // Tmp changes, reloading challenges everytime, since the user can change their school
        // and the school's curriculum is deciding what Challenges to show.
        // if (challenge_versions.length <= 0) {
        //     getChallengesFromServer();
        // }
    }, []);
    useEffect(() => {
        if (me) {
            setMeasure();
            const userChannel = pusher.subscribe('user_' + me.id);
            userChannel.bind('user.updated', getChallengesFromServer);

            return () => {
                userChannel.unbind();
                userChannel.unsubscribe();
            }
        }
    }, [me]);

    return (
        <div>
            {renderLoader()}

            <div className="section">
                <ChallengesFilter/>
            </div>

            {renderChallenges()}
        </div>
    );
}
